module.exports = __webpack_public_path__ + "gr.be0d63c3.svg";